export const sharedEN = {
	fiscalReportDateFilterHint:
		"This filter uses the transaction date, not the invoice issuance date.",
	fiscalReportDateFilterRechargeHint:
		"This filter uses the recharge date, not the invoice issuance date.",
};
